import { useState } from "react";
import { Button, DatePicker, Form, Modal, Space } from "antd";
import { translate } from "../../../../core";
import { dateFormat } from "../../../../core/until";
import { OrderPaymentRequest, OrderPaymentType } from "../../../order/type";
import {
  Combo,
  enumToComboOptionTransformer,
  StimulsoftViewer,
} from "../../../../core/component";

export const OrderPaymentsPageServerRendering = () => {
  const [request, setRequest] = useState<Record<string, any>>();
  const [form] = Form.useForm<OrderPaymentRequest>();
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);

  const isFormValid = async (): Promise<boolean> => {
    try {
      await form.validateFields({ validateOnly: true });
      return true;
    } catch {
      return false;
    }
  };

  const handleOK = async () => {
    if (await isFormValid()) {
      setConfirmModalVisible(false);
    }
    form.submit();
  };

  return (
    <>
      <Button
        onClick={() => setConfirmModalVisible(true)}
        className="btn-primary-gradient"
      >
        {translate("new_report")}
      </Button>
      <div className="print-hidden">
        <StimulsoftViewer
          name="order-payments"
          request={request}
          skip={!request}
        />
      </div>
      <Modal
        open={confirmModalVisible}
        onCancel={() => setConfirmModalVisible(false)}
        onOk={handleOK}
        okText={translate("get_report")}
        cancelText={translate("cancel")}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={(data) => {
            setRequest({
              type: data.type,
              minDate: data.minDate ? data.minDate.toISOString() : undefined,
              maxDate: data.maxDate ? data.maxDate.toISOString() : undefined,
            });
          }}
        >
          <Form.Item
            name="type"
            label={translate("type")}
            rules={[
              { required: true, message: translate("type", "is_required") },
            ]}
            style={{ maxWidth: 300 }}
          >
            <Combo<any, OrderPaymentType>
              size="middle"
              options={enumToComboOptionTransformer(OrderPaymentType)}
            />
          </Form.Item>

          <Space className="w-100">
            <Form.Item
              name="minDate"
              label={translate("min", "date")}
              rules={[
                {
                  required: true,
                  message: translate("min", "date", "is_required"),
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: "100%" }} />
            </Form.Item>

            <Form.Item
              name="maxDate"
              label={translate("max", "date")}
              rules={[
                {
                  required: true,
                  message: translate("max", "date", "is_required"),
                },
              ]}
            >
              <DatePicker format={dateFormat} style={{ width: "100%" }} />
            </Form.Item>
          </Space>
          <Space className="gap-1 my-3">
            <Button onClick={() => form.resetFields()}>
              {translate("clear")}
            </Button>
          </Space>
        </Form>
      </Modal>
    </>
  );
};
